<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap">
  <div class="row">
    <div class="col-md-12">
      <div class="page-breadcrumb">
        <ul class="page-breadcrumb__trail">
          <li><a>Reports</a></li>
          <li><a>Staff</a></li>
          <li><a>Visits</a></li>
        </ul>
        <div class="page-breadcrumb__icons" *ngIf="isVisitsInMobileView()">
          <a routerLink="/home"><img src="assets/images/New_Icons/home-transprent-icon.svg" title="Home"></a>
        </div>
      </div>
    </div>
    <!-- breadcrumb -->
    <!-- breadcrumb End -->
    <!-- Search Grid Start -->
    <div class="block">
      <div class="screen_heading_div">
        <span>Visits</span>
      </div>
      <div class="Reports_form_div visits-stats-container">

        <!--Initial Page loader block start-->
        <div *ngIf="initialPageLoader">
          <div class="adjust">
            <div class="reports-loader"></div>
          </div>
        </div>
        <!--Initial page loader block end-->

        <!--Initial content display on page load i.e Stats, PM's and PT's list, dealer reports and visits view options block start-->
        <div class="stats-reports-block" *ngIf="!initialPageLoader">

          <!--Provider manager or technician or both drop down selection block start-->
          <div class="reports-form-container dropdowns-container">
            <!--Provider Manager selection-->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Manager</mat-label>
              <mat-select (focus)="$providerManagersList = isManagerSelected ? $providerManagersList : $providerManagersListCpy"
                (selectionChange)="onManagerSelectionChange($event.value)"
                [(ngModel)]="selectedManagerObj">
                <mat-option value="" selected>All</mat-option>
                <mat-option *ngFor="let option of $providerManagersList" [value]="option">
                  {{ option.firstName + ' ' + option.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!--Provider Technician selection-->
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Technician</mat-label>
              <mat-select (focus)="$providerTechniciansList = isManagerSelected ? $providerTechniciansList : $providerTechniciansListCpy"
                (selectionChange)="onTechnicianSelectionChange($event.value)"
                [(ngModel)]="selectedTechnicianObj">
                <mat-option value="">All</mat-option>
                <mat-option *ngFor="let option of $providerTechniciansList" [value]="option">
                  {{ option.firstName + ' ' + option.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <!--Provider manager or technician or both drop down selection block end-->

          <!-- Provider manager or technician or both level stats data available block start-->

          <!--Visit aggregates collapsible section start-->
          <section class="collapsible" *ngIf="providerVisitsStats">
            <div class="collapsible-header" (click)="toggleAggregatesCollapse()">
              <h3>Visits Summary</h3>
              <span class="toggle-icon">{{ isAggregatesExpanded ? '▲' : '▼' }}</span>
            </div>
            <div class="collapsible-content" [class.expanded]="isAggregatesExpanded">
              <div class="group-1-aggregates">
                <div class="card">
                  <span class="label">Dealers</span>
                  <span class="value">{{ providerVisitsStats.dealers || '0' }}</span>
                </div>
                <div class="card">
                  <span class="label">Farmers</span>
                  <span class="value">{{ providerVisitsStats.farmers || '0' }}</span>
                </div>
                <div class="card">
                  <span class="label">Consultants</span>
                  <span class="value">{{ providerVisitsStats.smes || '0' }}</span>
                </div>
              </div>
              <div class="group-2-aggregates">
                <div class="total-visits">
                  <span class="label">Total Visits</span>
                  <span class="value">{{ providerVisitsStats.visits || '0' }}</span>
                </div>
                <div class="aggregates-tabs-container">
                  <div class="aggregates-tabs-header">
                    <button (click)="showHideStatsContentBlocks('Products')"
                            [class.active]="isProductsStatsBlockDisplay">Products
                    </button>
                    <button (click)="showHideStatsContentBlocks('Dues')" [class.active]="isDueStatsBlockDisplay">Dues
                    </button>
                    <button (click)="showHideStatsContentBlocks('Harvest')" [class.active]="isHarvestStatsBlockDisplay">
                      Harvest Farms
                    </button>
                  </div>
                  <div class="aggregates-tabs-content">
                    <div class="content" *ngIf="isProductsStatsBlockDisplay">
                      <div class="content-details">
                        <div class="stat">
                          <span class="value">{{ providerVisitsStats.products_placed || '0' }}</span>
                          <span class="label">Products Placed</span>
                        </div>
                        <div class="stat">
                          <span class="value">{{ providerVisitsStats.qty_placed || '0' }}</span>
                          <span class="label">Quantity Placed</span>
                        </div>
                      </div>
                    </div>
                    <div class="content" *ngIf="isDueStatsBlockDisplay">
                      <span class="content-info">Currency in INR</span>
                      <div class="content-details">
                        <div class="stat">
                          <span class="value">{{ (providerVisitsStats.paid | currencyFormat) || '0' }}</span>
                          <span class="label">Paid Amount</span>
                        </div>
                        <div class="stat">
                          <span class="value">{{ (providerVisitsStats.due | currencyFormat) || '0' }}</span>
                          <span class="label">Due Amount</span>
                        </div>
                      </div>
                    </div>
                    <div class="content" *ngIf="isHarvestStatsBlockDisplay">
                      <div class="content-details">
                        <div class="stat">
                          <span class="value">{{ providerVisitsStats.own_surveys || '0' }}</span>
                          <span class="label">Own</span>
                        </div>
                        <div class="stat">
                          <span class="value">{{ providerVisitsStats.competitor_surveys || '0' }}</span>
                          <span class="label">Competetior</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!--Visit aggregates collapsible section end-->

          <!-- Provider manager or technician or both level stats data available block end-->

          <!-- Provider manager or technician or both level stats data not available block start-->
          <div class="noDataFoundMessage" *ngIf="!providerVisitsStats">
            Stats data not available
          </div>
          <!-- Provider manager or technician or both level stats data not available block end-->

          <!--Dealer orders and dealer payments excel export options display block start-->

          <!--Export Reports collapsible section start-->
          <section class="collapsible" style="margin-top: 1rem;">
            <div class="collapsible-header" (click)="toggleCReportsCollapse()">
              <h3>Visit Reports</h3>
              <span class="toggle-icon">{{ isReportsExpanded ? '▲' : '▼' }}</span>
            </div>
            <div class="collapsible-content" [class.expanded]="isReportsExpanded">
              <div class="reports">
                <div class="card" (click)="exploreReportView('dealer_orders')" [class.active]="isDealerVisitReport">
                  <span class="label">Dealer visit</span>
                </div>
                <div class="card" (click)="exploreReportView('dealer_payments')" [class.active]="isDealerPaymentReport">
                  <span class="label">Dealer payments</span>
                </div>
                <div class="card" (click)="exploreReportView('farmer_visits')" [class.active]="isFarmerVisitReport">
                  <span class="label">Farmer visit</span>
                </div>
                <div class="card" (click)="exploreReportView('consultant_visits')"
                     [class.active]="isConsultantVisitReport">
                  <span class="label">Consultant visit</span>
                </div>
                <div class="card" (click)="exploreReportView('harvest_summary')"
                     [class.active]="isHarvestSummaryReport">
                  <span class="label">Harvest Summary</span>
                </div>
              </div>
              <div class="reports-explore-container">
                <!--Reports Container-->
                <div class="reports-block" style="position: relative">
                  <!--Reports Data Loader-->
                  <div *ngIf="reportsLoader" class="loader">
                    <div class="adjust report-loader-container">
                      <div class="loader2"></div>
                    </div>
                  </div>
                  <!--Reports Data container with filters-->
                  <div class="reports-container"
                       *ngIf="!reportsLoader && isVisitsDataAvailable() && isReportViewClicked">
                    <div style="margin-bottom: 2rem;">
                      <h4>Filters</h4>
                    </div>
                    <div class="reports-form-container visit-reports-container">
                      <!-- Existing or Competitor Custoemr Type drop down-->
                      <mat-form-field appearance="outline" class="w-100" *ngIf="isHarvestSummaryReport">
                        <mat-label>By Customer Type</mat-label>
                        <mat-select [(ngModel)]="typeOfCustomer"
                                    (selectionChange)="onCustomerTypeSelectionChange($event.value)">
                          <mat-option value="">All</mat-option>
                          <mat-option *ngFor="let option of getCustomerTypeFromResponse()" [value]="option">
                            {{ option }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <!-- Dealership Name or Farmer Name ot Consultant Name drop down-->
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>By {{ getFilterLableName() }}</mat-label>
                        <mat-select [(ngModel)]="visitorName"
                                    (selectionChange)="onVisitorSelectionChange($event.value)">
                          <mat-option value="">All</mat-option>
                          <mat-option *ngFor="let option of getBusinessesFromResponse()" [value]="option">
                            {{ option }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <!--Provider Technician Selection drop down-->
                      <mat-form-field appearance="outline" class="w-100" *ngIf="!isHarvestSummaryReport && !isTechnicianSelected">
                        <mat-label>By Technician</mat-label>
                        <mat-select [(ngModel)]="technicianName"
                                    (selectionChange)="onTechniciansSelectionChange($event.value)">
                          <mat-option value="">All</mat-option>
                          <mat-option *ngFor="let option of getTechniciansFromResponse()" [value]="option">
                            {{ option }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <!--Visit Location Selection drop down-->
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>By Location</mat-label>
                        <mat-select [(ngModel)]="locationName"
                                    (selectionChange)="onLocationSelectionChange($event.value)">
                          <mat-option value="">All</mat-option>
                          <mat-option *ngFor="let option of getLocationsFromResponse()" [value]="option">
                            {{ option }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <!--Harvest Summary Farm Businesses selection drop down-->
                      <mat-form-field appearance="outline" class="w-100" *ngIf="isHarvestSummaryReport">
                        <mat-label>By Business</mat-label>
                        <mat-select [(ngModel)]="farmBusinessName"
                                    (selectionChange)="onBusinessSelectionChange($event.value)">
                          <mat-option value="">All</mat-option>
                          <mat-option *ngFor="let option of getFarmBusinessFromResponse()" [value]="option">
                            {{ option }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <!--Date Range Filter selection-->
                      <mat-form-field appearance="outline" class="w-100">
                        <mat-label>By Date Range</mat-label>

                        <mat-date-range-input [rangePicker]="picker"
                                              [formGroup]="dateRangeForm"
                                              [max]="maxDate" 
                                              (focus)="picker.open()"
                                              (click)="picker.open()">
                          <input matStartDate placeholder="Start date" formControlName="start" readonly />
                          <input matEndDate placeholder="End date" formControlName="end" readonly />
                        </mat-date-range-input>

                        <!-- Dynamic icon: calendar or clear (×) -->
                        <button mat-icon-button
                          matSuffix
                          [ngClass]="isDateRangeSelected ? 'reports-toolbar__clear-btn' : ''"
                          [ngStyle]="{
                            'z-index': 1000,
                            'position': 'relative',
                            'background': 'none',
                            'border': 'none',
                            'box-shadow': 'none',
                            'outline': 'none'
                          }"
                          (click)="isDateRangeSelected ? clearDateRange() : picker.open()"
                          aria-label="Toggle date">

                          <!-- Show normal calendar icon if no filter applied -->
                          <mat-icon *ngIf="!isDateRangeSelected">calendar_today</mat-icon>

                          <!-- Show × if filter is applied -->
                          <span *ngIf="isDateRangeSelected"
                                style="font-size: 20px; font-weight: bold;">&times;</span>
                        </button>

                      <mat-date-range-picker #picker (closed)="onPickerClosed()"></mat-date-range-picker>
                      </mat-form-field>
                    </div>
                    <div class="actions-container">
                      <div class="action-icons">
                        <span class="excel-label">Download as Excel</span>
                        <img src="../../../../../../assets/images/New_Icons/Excel-export.svg" title="Excel downlaod"
                             (click)="exportReports()" width="30" height="30">
                      </div>
                    </div>
                    <!--Dealer Orders Report-->
                    <div class="report" *ngIf="isDealerVisitReport">
                      <div class="table-container">
                        <table class="table-bordered table-responsive-md">
                          <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Dealership</th>
                            <th>Location</th>
                            <th>Technician</th>
                            <th>Visit Date</th>
                            <th>Product</th>
                            <th>Qty</th>
                            <th>Price/Unit</th>
                            <th>Product Moved Qty</th>
                            <th>Product Returned Qty</th>
                            <th>Visit Number</th>
                            <th>Visit Remarks</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let data of dealervisits; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ data.visited_business_name || 'NA' }}</td>
                            <td>{{ data.site_name || 'NA' }}</td>
                            <td>{{ data.visiting_person_name || 'NA' }}</td>
                            <td>{{ data.visit_time | date: "dd MMM yyyy" : 'UTC' : 'en-US' }}</td>
                            <td>{{ data.product_name || 'NA' }}</td>
                            <td>{{ data.qty_placed | currencyFormat }}</td>
                            <td>{{ data.unit_price | currencyFormat }}</td>
                            <td>{{ data.qty_moved | currencyFormat }}</td>
                            <td>{{ data.qty_returned | currencyFormat }}</td>
                            <td>{{ data.visit_number }}</td>
                            <td>{{ data.remarks || 'NA' }}</td>
                          </tr>
                          <tr *ngIf="dealervisits.length == 0" class="no-data-row">
                            <td colspan="12">No Data Found</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <!--Dealer Payments Report-->
                    <div class="report" *ngIf="isDealerPaymentReport">
                      <div class="table-container">
                        <table class="table-bordered table-responsive-md">
                          <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Dealership</th>
                            <th>Dealer</th>
                            <th>Location</th>
                            <th>GST Number</th>
                            <th>Technician</th>
                            <th>Total amount</th>
                            <th>Paid amount</th>
                            <th>Due amount</th>
                            <th>Recent payment date</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let data of dealerpayments; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ data.visited_business_name || 'NA' }}</td>
                            <td>{{ data.visited_person_name || 'NA' }}</td>
                            <td>{{ data.site_name || 'NA' }}</td>
                            <td>NA</td>
                            <td>{{ data.visiting_person_name || 'NA' }}</td>
                            <td>{{ (data.ProviderVisitPayments?.[0]?.total_amount | currencyFormat) || 'NA' }}</td>
                            <td>{{ (data.ProviderVisitPayments?.[0]?.total_paid | currencyFormat) || 'NA' }}</td>
                            <td>{{ (data.ProviderVisitPayments?.[0]?.total_due | currencyFormat) || 'NA' }}</td>
                            <td>{{ data.date_time | date: "dd MMM yyyy" : 'UTC' : 'en-US' }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <!--Farmer Visit Report-->
                    <div class="report" *ngIf="isFarmerVisitReport">
                      <div class="table-container" id="zoomView">
                        <table class="table-bordered table-responsive-md">
                          <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Farmer</th>
                            <th>Location</th>
                            <th>Technician</th>
                            <th>Visit Date</th>
                            <th>Used Product</th>
                            <th>Qty</th>
                            <th>From Dealer</th>
                            <th>Other Products</th>
                            <th>Visit Number</th>
                            <th>Visit Remarks</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let data of farmerVisits; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ data.farmer_name || 'NA' }}</td>
                            <td>{{ data.site_name || 'NA' }}</td>
                            <td>{{ data.visiting_person_name || 'NA' }}</td>
                            <td>{{ data.visit_time | date: "dd MMM yyyy" : 'UTC' : 'en-US' }}</td>
                            <td>{{ data.product_name || 'NA' }}</td>
                            <td>{{ data.qty_used || '0' }}</td>
                            <td>{{ data.from_dealer || 'NA' }}</td>
                            <td>{{ data.other_products || 'NA' }}</td>
                            <td>{{ data.visit_number }}</td>
                            <td>{{ data.remarks || 'NA' }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <!--Consultant Visit Report-->
                    <div class="report" *ngIf="isConsultantVisitReport">
                      <div class="table-container" id="zoomView">
                        <table class="table-bordered table-responsive-md">
                          <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Consultant</th>
                            <th>Location</th>
                            <th>Technician</th>
                            <th>Visit Date</th>
                            <th>Products discussed</th>
                            <th>Product feedback</th>
                            <th>Visit Number</th>
                            <th>Visit Remarks</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let data of consultantVisits; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ data.consultant_name || 'NA' }}</td>
                            <td>{{ data.site_name || 'NA' }}</td>
                            <td>{{ data.visiting_person_name || 'NA' }}</td>
                            <td>{{ data.visit_time | date: "dd MMM yyyy" : 'UTC' : 'en-US' }}</td>
                            <td>{{ data.product_name || 'NA' }}</td>
                            <td>{{ data.feedback || 'NA' }}</td>
                            <td>{{ data.visit_number }}</td>
                            <td>{{ data.remarks || 'NA' }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <!--Harvest Summary Report-->
                    <div class="report" *ngIf="isHarvestSummaryReport">
                      <div class="table-container" id="zoomView">
                        <table class="table-bordered table-responsive-md">
                          <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Customer</th>
                            <th>Farm</th>
                            <th>MPEDA</th>
                            <th>Farmer</th>
                            <th>Mobile</th>
                            <th>Location</th>
                            <th>Ponds</th>
                            <th>Pond bottom</th>
                            <th>Salinity(ppt)</th>
                            <th>Pond size(M2)</th>
                            <th>Pond size(Ha)</th>
                            <th>Aeration level(Hp/Ha)</th>
                            <th>Date of stocked</th>
                            <th>Date of harvest</th>
                            <th>DOC</th>
                            <th>Hatchery</th>
                            <th>PL age</th>
                            <th>Stocked Number</th>
                            <th>Number/M2</th>
                            <th>Feed Brand details</th>
                            <th>Cumulative feed(KG)</th>
                            <th>Biomass (KG/Pond)</th>
                            <th>Production level(KG/Ha)</th>
                            <th>Final body weight(grms)</th>
                            <th>ADG</th>
                            <th>Survival rate(%)</th>
                            <th>FCR</th>
                            <th>Remarks</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let data of harvestSummaries; let i = index">
                            <td>{{ i + 1 }}</td>
                            <td>{{ data.customer_type }}</td>
                            <td>{{ data.farm_name || 'NA' }}</td>
                            <td>{{ data.mpeda || 'NA' }}</td>
                            <td>{{ data.farmer_name || 'NA' }}</td>
                            <td>{{ data.mobile_number || 'NA' }}</td>
                            <td>{{ data.site_name || 'NA' }}</td>
                            <td>{{ data.pond_count || 'NA' }}</td>
                            <td>{{ data.pond_bottom || 'NA' }}</td>
                            <td>{{ data.salinity || 'NA' }}</td>
                            <td>{{ data.pond_size_m2 || 'NA' }}</td>
                            <td>{{ data.pond_size_ha || 'NA' }}</td>
                            <td>{{ data.areation_level || 'NA' }}</td>
                            <td>{{ data.stocked_date | date: "dd MMM yyyy" : 'UTC' : 'en-US' }}</td>
                            <td>{{ data.harvested_date | date: "dd MMM yyyy" : 'UTC' : 'en-US' }}</td>
                            <td>{{ data.doc || 'NA' }}</td>
                            <td>{{ data.hatchery_name || 'NA' }}</td>
                            <td>{{ data.pl_age || 'NA' }}</td>
                            <td>{{ data.stocked_number || 'NA' }}</td>
                            <td>{{ data.number_per_m2 || 'NA' }}</td>
                            <td>{{ data.feed_brand_details || 'NA' }}</td>
                            <td>{{ data.cumulative_feed || 'NA' }}</td>
                            <td>{{ data.biomass || 'NA' }}</td>
                            <td>{{ data.production || 'NA' }}</td>
                            <td>{{ data.final_body_weight || 'NA' }}</td>
                            <td>{{ data.adg || 'NA' }}</td>
                            <td>{{ data.survival_rate || 'NA' }}</td>
                            <td>{{ data.fcr || 'NA' }}</td>
                            <td>{{ data.remarks || 'NA' }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <!--When Service fails or there is no data-->
                  <div class="noDataFoundMessage"
                       *ngIf="!reportsLoader && !isVisitsDataAvailable() && isReportViewClicked && isErrorOccured">
                    Unable to Fetch Data Please try again
                  </div>
                  <div class="noDataFoundMessage"
                       *ngIf="!reportsLoader && !isVisitsDataAvailable() && isReportViewClicked && !isErrorOccured">
                    Data not found
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!--Export Reports collapsible section end-->

          <!--Dealer orders and dealer payments excel export options display block end-->

          <!--Tabular to map view and vide versa switch changing block start-->
          <section class="approvals-container">
            <div class="approvals-info">
              <div>
                <h3>Visit Approvals</h3>
                <div class="visits-view-options" *ngIf="!isWebViewOptionsClicked">
                  <div (click)="toogleVisitsViewState('tabularView')" [class.active]="isTabularView">
                    <span>Table view</span>
                    <svg
                      width="19"
                      height="18"
                      viewBox="0 0 19 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon"
                    >
                      <path
                        opacity="0.3"
                        d="M16.9194 6V8H6.85229V6H16.9194ZM10.8791 12V10H12.8926V12H10.8791ZM12.8926 14V16H10.8791V14H12.8926ZM8.86572 12H6.85229V10H8.86572V12ZM14.906 10H16.9194V12H14.906V10ZM6.85229 14H8.86572V16H6.85229V14ZM14.906 16V14H16.9194V16H14.906Z"
                        fill="currentColor"
                      />
                      <path
                        d="M16.9194 4H6.85228C5.7449 4 4.83886 4.9 4.83886 6V16C4.83886 17.1 5.7449 18 6.85228 18H16.9194C18.0268 18 18.9328 17.1 18.9328 16V6C18.9328 4.9 18.0268 4 16.9194 4ZM16.9194 6V8H6.85228V6H16.9194ZM10.8791 12V10H12.8925V12H10.8791ZM12.8925 14V16H10.8791V14H12.8925ZM8.8657 12H6.85228V10H8.8657V12ZM14.906 10H16.9194V12H14.906V10ZM6.85228 14H8.8657V16H6.85228V14ZM14.906 16V14H16.9194V16H14.906ZM3.83215 14H2.82543C1.71805 14 0.812012 13.1 0.812012 12V2C0.812012 0.9 1.71805 0 2.82543 0H12.8925C13.9999 0 14.906 0.9 14.906 2V3H12.8925V2H2.82543V12H3.83215V14Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <div (click)="toogleVisitsViewState('mapView')" [class.active]="isMapView">
                    <span>Map view</span>
                    <svg
                      width="18"
                      height="24"
                      viewBox="0 0 18 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon"
                    >
                      <path
                        d="M4.96289 17.7833C5.70915 18.6681 6.38839 19.6002 6.9957 20.5726C7.51419 21.4872 7.73033 22.1074 8.10925 23.2094C8.34163 23.8183 8.55166 24 9.0032 24C9.49525 24 9.7185 23.6908 9.89097 23.2127C10.2491 22.172 10.5302 21.3778 10.9736 20.6273C11.8436 19.1784 12.9248 17.8909 13.987 16.6535C14.2746 16.3033 16.134 14.263 16.971 12.6532C16.971 12.6532 17.9999 10.8847 17.9999 8.41495C17.9999 6.10472 16.9853 4.50244 16.9853 4.50244L14.0641 5.23022L12.2901 9.57694L11.8512 10.1763L11.7635 10.2849L11.6468 10.4208L11.4419 10.6379L11.1491 10.9102L9.56936 12.1075L5.61989 14.229L4.96289 17.7833Z"
                        fill="currentColor"
                      />
                      <path
                        d="M0.886719 12.3558C1.85064 14.404 3.70943 16.2046 4.96704 17.7847L11.6468 10.4235C11.6468 10.4235 10.7058 11.5685 8.9987 11.5685C7.09724 11.5685 5.56111 10.1559 5.56111 8.37476C5.56111 7.15332 6.35101 6.31421 6.35101 6.31421L1.81661 7.44453L0.886719 12.3558Z"
                        fill="currentColor"
                      />
                      <path
                        d="M11.7214 0.378662C13.9399 1.0441 15.8388 2.44111 16.9873 4.50115L11.6488 10.4195C11.6488 10.4195 12.4387 9.56524 12.4387 8.35138C12.4387 6.52873 10.789 5.16711 9.00677 5.16711C7.32144 5.16711 6.35352 6.31019 6.35352 6.31019V2.58169L11.7214 0.378662Z"
                        fill="currentColor"
                      />
                      <path
                        d="M2.11035 2.9936C3.4354 1.51874 5.76697 0 8.98139 0C10.5409 0 11.7159 0.380896 11.7159 0.380896L6.34845 6.31334H2.54559L2.11035 2.9936Z"
                        fill="currentColor"
                      />
                      <path
                        d="M0.886785 12.3559C0.886785 12.3559 0 10.7404 0 8.39992C0 6.18787 0.924332 4.25428 2.11044 2.99365L6.35156 6.31392L0.886785 12.3559Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div class="visits-mobile-view-options" *ngIf="isWebViewOptionsClicked">
                <div (click)="toogleVisitsViewState('tabularView')">
                  <svg
                    width="19"
                    height="18"
                    viewBox="0 0 19 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon"
                    [class.active]="isTabularView">
                    <path
                      opacity="0.3"
                      d="M16.9194 6V8H6.85229V6H16.9194ZM10.8791 12V10H12.8926V12H10.8791ZM12.8926 14V16H10.8791V14H12.8926ZM8.86572 12H6.85229V10H8.86572V12ZM14.906 10H16.9194V12H14.906V10ZM6.85229 14H8.86572V16H6.85229V14ZM14.906 16V14H16.9194V16H14.906Z"
                      fill="currentColor"
                    />
                    <path
                      d="M16.9194 4H6.85228C5.7449 4 4.83886 4.9 4.83886 6V16C4.83886 17.1 5.7449 18 6.85228 18H16.9194C18.0268 18 18.9328 17.1 18.9328 16V6C18.9328 4.9 18.0268 4 16.9194 4ZM16.9194 6V8H6.85228V6H16.9194ZM10.8791 12V10H12.8925V12H10.8791ZM12.8925 14V16H10.8791V14H12.8925ZM8.8657 12H6.85228V10H8.8657V12ZM14.906 10H16.9194V12H14.906V10ZM6.85228 14H8.8657V16H6.85228V14ZM14.906 16V14H16.9194V16H14.906ZM3.83215 14H2.82543C1.71805 14 0.812012 13.1 0.812012 12V2C0.812012 0.9 1.71805 0 2.82543 0H12.8925C13.9999 0 14.906 0.9 14.906 2V3H12.8925V2H2.82543V12H3.83215V14Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <div (click)="toogleVisitsViewState('mapView')">
                  <svg
                    width="18"
                    height="24"
                    viewBox="0 0 18 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon" [class.active]="isMapView"
                  >
                    <path
                      d="M4.96289 17.7833C5.70915 18.6681 6.38839 19.6002 6.9957 20.5726C7.51419 21.4872 7.73033 22.1074 8.10925 23.2094C8.34163 23.8183 8.55166 24 9.0032 24C9.49525 24 9.7185 23.6908 9.89097 23.2127C10.2491 22.172 10.5302 21.3778 10.9736 20.6273C11.8436 19.1784 12.9248 17.8909 13.987 16.6535C14.2746 16.3033 16.134 14.263 16.971 12.6532C16.971 12.6532 17.9999 10.8847 17.9999 8.41495C17.9999 6.10472 16.9853 4.50244 16.9853 4.50244L14.0641 5.23022L12.2901 9.57694L11.8512 10.1763L11.7635 10.2849L11.6468 10.4208L11.4419 10.6379L11.1491 10.9102L9.56936 12.1075L5.61989 14.229L4.96289 17.7833Z"
                      fill="currentColor"
                    />
                    <path
                      d="M0.886719 12.3558C1.85064 14.404 3.70943 16.2046 4.96704 17.7847L11.6468 10.4235C11.6468 10.4235 10.7058 11.5685 8.9987 11.5685C7.09724 11.5685 5.56111 10.1559 5.56111 8.37476C5.56111 7.15332 6.35101 6.31421 6.35101 6.31421L1.81661 7.44453L0.886719 12.3558Z"
                      fill="currentColor"
                    />
                    <path
                      d="M11.7214 0.378662C13.9399 1.0441 15.8388 2.44111 16.9873 4.50115L11.6488 10.4195C11.6488 10.4195 12.4387 9.56524 12.4387 8.35138C12.4387 6.52873 10.789 5.16711 9.00677 5.16711C7.32144 5.16711 6.35352 6.31019 6.35352 6.31019V2.58169L11.7214 0.378662Z"
                      fill="currentColor"
                    />
                    <path
                      d="M2.11035 2.9936C3.4354 1.51874 5.76697 0 8.98139 0C10.5409 0 11.7159 0.380896 11.7159 0.380896L6.34845 6.31334H2.54559L2.11035 2.9936Z"
                      fill="currentColor"
                    />
                    <path
                      d="M0.886785 12.3559C0.886785 12.3559 0 10.7404 0 8.39992C0 6.18787 0.924332 4.25428 2.11044 2.99365L6.35156 6.31392L0.886785 12.3559Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
              </div>
            </div>

            <div class="visits-container approvals-visits-container" *ngIf="isTabularView || isMapView">
              <!--Visits filters block start-->
              <div class="filters-block">
                <div class="dates-filter-block" style="position: relative;">
                    <span
                      [ngClass]="{ 'active': selectedDateFilter === 'Today' }"
                      (click)="setDateFilter('Today')">
                      <span class="desktop-label">Today</span>
                      <span class="mobile-label">Today</span>
                    </span>
                  <span
                    [ngClass]="{ 'active': selectedDateFilter === '1W' }"
                    (click)="setDateFilter('1W')">
                      <span class="desktop-label">Last Week</span>
                      <span class="mobile-label">1W</span>
                    </span>
                  <span
                    [ngClass]="{ 'active': selectedDateFilter === '1M' }"
                    (click)="setDateFilter('1M')">
                      <span class="desktop-label">Last Month</span>
                      <span class="mobile-label">1M</span>
                    </span>
                  <span
                    [ngClass]="{ 'active': selectedDateFilter === '6M' }"
                    (click)="setDateFilter('6M')">
                      <span class="desktop-label">Last 6 Months</span>
                      <span class="mobile-label">6M</span>
                    </span>
                  <span
                    [ngClass]="{ 'active': selectedDateFilter === 'Custom' }"
                    (click)="openDateRangePopup()">
                      <span *ngIf="customFromDate == '' && customToDate == ''">Custom</span>
                      <span *ngIf="customFromDate != '' && customToDate != ''">{{ customFromDate }}
                        - {{ customToDate }}</span>
                    </span>
                </div>


                <app-date-range-popup
                  *ngIf="isDateRangePopupOpen"
                  [fromDate]="customFromDate"
                  [toDate]="customToDate"
                  (close)="closeDateRangePopup()"
                  (apply)="onDateRangeApply($event)">
                </app-date-range-popup>

                <div class="status-action-filter" *ngIf="isTabularView">
                  <span>Visit Status</span>
                  <select [(ngModel)]="selectedVisitStatus" class="action-select"
                          (change)="isStatusFilterSelected = true;updateVisitsDataOnAction()">
                    <option value="P">Pending</option>
                    <option value="A">Accepted</option>
                    <option value="R">Rejected</option>
                  </select>
                </div>
              </div>
              <!--Visits filters block end-->
              <!--Tabular view block start-->
              <div class="tabular-view-container" *ngIf="isTabularView">

                <!--Visits data loader block start-->
                <div *ngIf="tabularViewLoader" style="position: relative">
                  <div class="adjust">
                    <div class="reports-loader"></div>
                  </div>
                </div>
                <!--Visits data loader block end-->

                <!--Visits data on available block start-->
                <div *ngIf="providerVisitsListOriginal?.length > 0 && !tabularViewLoader">
                  <!--Search, sort and legends display block start-->
                  <div class="filter-actions">
                    <!--Search, sort and legends display block start-->
                    <div class="search-sort-container">
                      <!-- Search Bar -->
                      <div class="search-div">
                        <img src="../../../../../assets/images/New_Icons/search-icon.svg">
                        <input type="text" (keyup)="updateVisitsDataOnAction()" [(ngModel)]="search" name="search"
                               autocomplete="off" placeholder="by technician..">
                        <button *ngIf="this.search != ''" type="button" title="clear search" class="searchClose"
                                (click)="search = '';updateVisitsDataOnAction()">&times;
                        </button>
                      </div>
                      <!-- Sort Button -->
                      <button class="sort-button" (click)="toggleSortOrder()"
                              [ngClass]="isSortedAsc ? 'sorted-asc' : 'sorted-desc'" title="sort">
                        <img src="../../../../../../assets/img/png-icons-blubay/filter icon.svg" alt="Sort"
                             class="sort-icon-img">
                      </button>
                    </div>
                    <!-- Legends -->
                    <div class="legend">
                        <span class="legend-item dealer">
                          <span class="legend-box"></span>
                          <span class="legend-label">Dealer</span>
                        </span>
                      <span class="legend-item farmers">
                          <span class="legend-box"></span>
                          <span class="legend-label">Farmer</span>
                        </span>
                      <span class="legend-item consultant">
                          <span class="legend-box"></span>
                          <span class="legend-label">consultant</span>
                        </span>
                    </div>
                  </div>
                  <!--Search, sort and legends display block end-->

                  <!--Visits list web display block start-->
                  <div class="visitsList web-view-visits-list"
                       [ngClass]="{ 'visits-list-scrollable': providerVisitsList?.length > 6 }">
                    <div
                      class="visit-card tooltip-container"
                      (click)="getVisitDetailsByVisitId(visit)"
                      *ngFor="let visit of providerVisitsList"
                      data-tooltip="Click to view visit details"
                    >
                      <div class="section badge-section">
                        <div
                          class="badge"
                          [ngClass]="{
                              'background-blue': visit.visited_business_type === 'dealer',
                              'background-orange': visit.visited_business_type === 'farm',
                              'background-green': visit.visited_business_type === 'sme'
                            }"
                        >
                          {{
                            visit.visited_business_type === 'dealer'
                              ? 'D'
                              : visit.visited_business_type === 'farm'
                                ? 'F'
                                : 'C'
                          }}
                        </div>
                        <div class="id-date">
                          <h4 class="id">{{ visit.visit_number }}</h4>
                          <p class="date">{{ visit.date_time | date: 'dd MMM yyyy' }}</p>
                        </div>
                      </div>
                      <div class="section details-section">
                        <span class="visited-person">{{ visit.visited_person_name }}</span>
                        <span class="site-name">{{ visit.site_name }}</span>
                      </div>
                      <div class="section remarks-section">
                        <span class="remarks">{{ visit.remarks }}</span>
                      </div>
                      <div class="section photo-section">
                        <!-- Loader -->
                        <div *ngIf="visit.isImageLoading" style="position: absolute;right: 20%;">
                          <div class="adjust">
                            <div class="image-loader"></div>
                          </div>
                        </div>

                        <!-- Content (Image or No Image Template) -->
                        <div *ngIf="!visit.isImageLoading">
                          <ng-container *ngIf="![''].includes(visit.imageBase64String); else noImageTemplate">
                            <img
                              [src]="visit.imageBase64String"
                              alt="Attachment"
                              class="image"
                            />
                          </ng-container>

                          <!-- No Image Template -->
                          <ng-template #noImageTemplate>
                            <div class="no-image">
                              No Image
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--Visits list web display block end-->

                  <!--Visits list mobile display block start-->
                  <div class="visitsList mobile-view-visits-list"
                       [ngClass]="{ 'visits-list-scrollable': providerVisitsList?.length > 6 }">
                    <div class="mobile-visit-card tooltip-container" (click)="getVisitDetailsByVisitId(visit)"
                         *ngFor="let visit of providerVisitsList" data-tooltip="Click to view visit details">
                      <div class="mobile-left-section">
                        <div
                          class="badge"
                          [ngClass]="{
                              'background-blue': visit.visited_business_type === 'dealer',
                              'background-orange': visit.visited_business_type === 'farm',
                              'background-green': visit.visited_business_type === 'sme'
                            }"
                        >
                          {{
                            visit.visited_business_type === 'dealer'
                              ? 'D'
                              : visit.visited_business_type === 'farm'
                                ? 'F'
                                : 'C'
                          }}
                        </div>
                      </div>
                      <div class="mobile-middle-section">
                        <div class="mobile-id-date">
                          <h4 class="id"># {{ visit.visit_number }}</h4>
                          <p class="date">{{ visit.date_time | date: 'dd MMM yyyy' }}</p>
                        </div>
                        <div class="mobile-details">
                          <span class="visited-person">{{ visit.visited_person_name }}</span>
                          <span class="site-name">{{ visit.site_name }}</span>
                        </div>
                        <div class="mobile-remarks">
                          {{ visit.remarks }}
                        </div>
                      </div>
                      <div class="section mobile-photo-section">
                        <!-- Loader -->
                        <div *ngIf="visit.isImageLoading" style="position: absolute;right: 20%;">
                          <div class="adjust">
                            <div class="image-loader"></div>
                          </div>
                        </div>

                        <!-- Content (Image or No Image Template) -->
                        <div *ngIf="!visit.isImageLoading">
                          <ng-container *ngIf="![''].includes(visit.imageBase64String); else noImage">
                            <img
                              [src]="visit.imageBase64String"
                              alt="Attachment"
                              class="image"
                            />
                          </ng-container>

                          <!-- No Image Template -->
                          <ng-template #noImage>
                            <div class="mobile-no-image">
                              No Image
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--Visits list mobile display block end-->

                  <!--Visits data empty on filter by search, status and time range block start -->
                  <div class="noDataFoundMessage" *ngIf="providerVisitsList?.length == 0">
                    {{ search == '' ? 'No item matches your filter by status and data range' : 'No items matches your search' }}
                  </div>
                  <!--Visits data empty on filter by search, status and time range block end -->

                </div>
                <!--Visits data on available block end-->

                <!--Visits data not available block start-->
                <div *ngIf="providerVisitsListOriginal?.length == 0 && !tabularViewLoader" class="noDataFoundMessage">
                  Visits Data not found
                </div>
                <!--Visits data not available block end-->

              </div>
              <!--Tabular view block end-->

              <!--Map view block start-->
              <div class="map-view-container" *ngIf="isMapView">

                <!-- Location tracker data loader block start-->
                <div *ngIf="mapsViewLoader" style="position: relative">
                  <div class="adjust">
                    <div class="reports-loader"></div>
                  </div>
                </div>
                <!-- Location tracker data loader block end-->

                <!--Location tracker details on available block start-->
                <div *ngIf="locationTrackingDetailsOriginal?.length > 0 && !mapsViewLoader">
                  <!--location tracking details in map view display block start-->
                  <div class="visits-map-view-block" *ngIf="locationTrackingDetails?.length" id="mapsContainer">
                    <p class="map-info"><img src="assets/img/info.png" width="20px" height="20px"> Need to be zoom in to
                      view markers in maps </p>
                    <google-map #gm [width]="'100%'" (mapInitialized)="onMapReady(gm)">
                      <map-marker *ngFor="let location of locationTrackingDetails"
                                  #marker="mapMarker"
                                  [position]="{ lat: location.atFarmOnlatitude, lng: location.atFarmOnlongitude }"
                                  [options]="{ title: 'Marker' }"
                                  (mapClick)="onLocationMouseOverClick(marker, location)">
                      </map-marker>

                      <map-info-window #infoWindow>
                        <div style="text-align: left; width: 100%;">
                          <p>Person: {{ locationTrackingInfoDetails?.visited_person_name }}</p>
                          <p>Business: {{ locationTrackingInfoDetails?.visiting_business_name }}</p>
                          <p>Technician: {{ locationTrackingInfoDetails?.visiting_person_name }}</p>
                          <p>Site: {{ locationTrackingInfoDetails?.site_name }}</p>
                          <p>
                            Spend: {{ locationTrackingInfoDetails?.in_time | timeFormat: locationTrackingInfoDetails?.out_time }}</p>
                          <p>Date: {{ locationTrackingInfoDetails?.date_time | date:'dd MMM yyyy' }}</p>
                        </div>
                      </map-info-window>
                    </google-map>

                  </div>
                  <!--location tracking details in map view display block end-->

                  <!--location tracking details data empty on filter by time range in map view-->
                  <div class="noDataFoundMessage" *ngIf="locationTrackingDetails?.length == 0">
                    {{ 'No item matches your date range' }}
                  </div>
                </div>
                <!--Location tracker details on available block end-->

                <!--Location tracker details not available block start-->
                <div *ngIf="locationTrackingDetailsOriginal?.length == 0 && !mapsViewLoader" class="noDataFoundMessage">
                  Tracking details not found
                </div>
                <!--Location tracker details not available block end-->
              </div>
              <!--Map view block end-->
            </div>
          </section>
          <!--Tabular to map view and vide versa switch changing block end-->
        </div>
        <!--Initial content display on page load i.e Stats, PM's and PT's list, dealer reports and visits view options block end-->

        <div class="custom-modal" id="custom-modal">
          <div class="custom-modal-content">
            <!-- Close button -->
            <span class="custom-modal-close" (click)="closePopup()">&times;</span>

            <!--Part -1: Visit Status-->
            <div class="visit-status" *ngIf="visitObject?.status != 'P'">
              <span class="status"
                    [ngClass]="visitObject?.status == 'A' ? 'status-accepted' : 'status-rejected'">{{ visitObject?.status == 'A' ? 'Accepted' : 'Rejected' }}</span>
              <div class="visit-remarks">
                <span><strong>Comment:</strong> <span class="remark-content">{{ visitObject?.remarks }}</span></span>
              </div>
            </div>

            <!-- Part 1: Visit Details -->
            <div class="visit-details" *ngIf="visitObject">
              <div class="visit-header">
                <span class="main-info">Visit # {{ visitObject.visit_number }}</span>
                <span class="sub-info">{{ visitObject.date_time | date:"dd MMM yyyy" }}</span>
                <span class="sub-info">{{ visitObject.visiting_person_name }}
                  <br><span>Spend {{ visitObject.in_time | timeFormat: visitObject.out_time }}</span></span>
              </div>
              <div class="visit-body">
                <p class="visited-title">Visited: <span class="horizontal-line"></span></p>
                <div class="visit-body-content">
                  <div class="visit-info">
                    <div class="business-info">
                      <span>{{ visitObject.visited_business_name }}</span>
                      <span>{{ visitObject.visited_person_name }}</span>
                    </div>
                    <div class="visit-remarks" *ngIf="visitObject.status == 'P'">
                      <span><strong>Remark:</strong> <span
                        class="remark-content">{{ visitObject.remarks }}</span></span>
                    </div>
                  </div>
                  <button class="view-photo" *ngIf="![''].includes(visitObject.imageBase64String)">
                    <img [src]="visitObject.imageBase64String">
                  </button>
                </div>
              </div>
            </div>

            <!--Displaying an loader until the visit details is being fetched-->
            <div *ngIf="visitDetailsLoader">
              <div class="adjust">
                <div class="reports-loader"></div>
              </div>
            </div>

            <!-- Part 2: Visit Activities (Scrollable Section) -->
            <div class="visit-activities" *ngIf="!visitDetailsLoader">
              <div *ngIf="visitObjectDetails && visitObjectDetails.length > 0">
                <div *ngIf="visitObject.visited_business_type == 'dealer'">
                  <div class="activities-tabs-header" *ngIf="visitObjectDetails?.[0].activitiesCount > 1">
                    <button (click)="showHideVisitDetailsContentBlocks('Placements')"
                            [class.active]="isPlacementsDataDisplay"
                            *ngIf="visitObjectDetails?.[0].productPlacements.length > 0">Placements
                    </button>
                    <button (click)="showHideVisitDetailsContentBlocks('Movements')"
                            [class.active]="isMovementsDataDisplay"
                            *ngIf="visitObjectDetails?.[0].productMovements.length > 0">Movements
                    </button>
                    <button (click)="showHideVisitDetailsContentBlocks('Returns')" [class.active]="isReturnsDataDisplay"
                            *ngIf="visitObjectDetails?.[0].productReturns.length > 0">Returns
                    </button>
                    <button (click)="showHideVisitDetailsContentBlocks('Payments')"
                            [class.active]="isPaymentsDataDisplay"
                            *ngIf="visitObjectDetails?.[0].ProviderVisitPayments.length > 0">Payments
                    </button>
                  </div>
                  <div class="activity-content" *ngIf="isPlacementsDataDisplay">
                    <h4 *ngIf="visitObjectDetails?.[0].activitiesCount == 1">List of Products placed</h4>
                    <div class="table-container" *ngIf="visitObjectDetails?.[0].productPlacements.length > 0">
                      <table>
                        <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Product</th>
                          <th>Quantity</th>
                          <th>Unit</th>
                          <th>Price/Qty</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                          *ngFor="let list of visitObjectDetails[0].productPlacements; let i = index">
                          <td>{{ i + 1 }}</td>
                          <td>{{ list.product_name || 'NA' }}</td>
                          <td>{{ list.qty || 'NA' }}</td>
                          <td>{{ list.product_uom_name || 'NA' }}</td>
                          <td>{{ list.price_per_placed_qty | currencyFormat }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="activity-content" *ngIf="isMovementsDataDisplay">
                    <h4 *ngIf="visitObjectDetails?.[0].activitiesCount == 1">List of products moved</h4>
                    <div class="table-container" *ngIf="visitObjectDetails?.[0].productMovements.length > 0">
                      <table>
                        <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Product</th>
                          <th>Quantity</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                          *ngFor="let list of visitObjectDetails[0].productMovements; let i = index">
                          <td>{{ i + 1 }}</td>
                          <td>{{ list.product_name || 'NA' }}</td>
                          <td>{{ list.qty || 'NA' }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="activity-content" *ngIf="isReturnsDataDisplay">
                    <h4 *ngIf="visitObjectDetails?.[0].activitiesCount == 1">List of products returned</h4>
                    <div class="table-container" *ngIf="visitObjectDetails?.[0].productReturns.length > 0">
                      <table>
                        <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Product</th>
                          <th>Quantity</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                          *ngFor="let list of visitObjectDetails[0].productReturns; let i = index">
                          <td>{{ i + 1 }}</td>
                          <td>{{ list.product_name || 'NA' }}</td>
                          <td>{{ list.qty || 'NA' }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="activity-content" *ngIf="isPaymentsDataDisplay">
                    <h4 *ngIf="visitObjectDetails?.[0].activitiesCount == 1">List of payment details</h4>
                    <div class="table-container" *ngIf="visitObjectDetails?.[0].ProviderVisitPayments.length > 0">
                      <table>
                        <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Amount</th>
                          <th>Paid</th>
                          <th>Due</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                          *ngFor="let list of visitObjectDetails[0].ProviderVisitPayments; let i = index">
                          <td>{{ i + 1 }}</td>
                          <td>{{ list.amount  | currencyFormat }}</td>
                          <td>{{ list.paid | currencyFormat }}</td>
                          <td>{{ list.due | currencyFormat }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div *ngIf="visitObject.visited_business_type == 'farm'">
                  <div class="activities-tabs-header" *ngIf="visitObjectDetails?.[0].activitiesCount > 1">
                    <button (click)="showHideVisitDetailsContentBlocks('ListOfProductsUsed')"
                            [class.active]="isProductsUsageDisplayed"
                            *ngIf="visitObjectDetails?.[0].productUsages.length > 0">Product Usages
                    </button>
                    <button (click)="showHideVisitDetailsContentBlocks('harvestSummary')"
                            [class.active]="isHarvestSummaryDisplayed"
                            *ngIf="visitObjectDetails?.[0].ProviderVisitSurveys.length > 0">Harvest Summary Data
                    </button>
                  </div>
                  <div class="activity-content" *ngIf="isProductsUsageDisplayed">
                    <h4 *ngIf="visitObjectDetails?.[0].activitiesCount == 1">List of products used</h4>
                    <div class="table-container" *ngIf="visitObjectDetails?.[0].productUsages.length > 0">
                      <table>
                        <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Product</th>
                          <th>Quantity</th>
                          <th>Other Products</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                          *ngFor="let list of visitObjectDetails[0].productUsages; let i = index">
                          <td>{{ i + 1 }}</td>
                          <td>{{ list.product_name || 'NA' }}</td>
                          <td>{{ list.qty || 'NA' }}</td>
                          <td>{{ list.other_product_details || 'NA' }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="activity-content" *ngIf="isHarvestSummaryDisplayed">
                    <h4 *ngIf="visitObjectDetails?.[0].activitiesCount == 1">Harvest Sumary Data</h4>
                    <div class="main-data-container" *ngIf="visitObjectDetails?.[0].ProviderVisitSurveys.length > 0">
                      <div class="data-container"
                           *ngFor="let harvestData of visitObjectDetails?.[0].ProviderVisitSurveys">
                        <div class="data-item">
                          <span class="data-key">Survey Type</span>
                          <span class="data-value">{{ harvestData.survey_type || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Survey Date</span>
                          <span class="data-value">{{ (harvestData.survey_date | date: "dd MMM yyyy") || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Farm Type</span>
                          <span class="data-value">{{ harvestData.farm_type || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Farm Name</span>
                          <span class="data-value">{{ harvestData.farm_name || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Site Name</span>
                          <span class="data-value">{{ harvestData.farm_site_name || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Farmer Name</span>
                          <span class="data-value">{{ harvestData.farmer_name || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Mobile number</span>
                          <span class="data-value">{{ harvestData.mobile_number || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">No of ponds</span>
                          <span class="data-value">{{ harvestData.no_of_ponds || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Salinity</span>
                          <span class="data-value">{{ harvestData.salinity || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Stocked Date</span>
                          <span class="data-value">{{ (harvestData.stocked_date | date: "dd MMM yyyy") || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">No of ponds</span>
                          <span class="data-value">{{ harvestData.no_of_ponds || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Pond bottom type</span>
                          <span class="data-value">{{ harvestData.pond_bottom_type || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">m2 pond size</span>
                          <span class="data-value">{{ harvestData.m2_pond_size || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Aeriation level</span>
                          <span class="data-value">{{ harvestData.areation_level || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Harvested Date</span>
                          <span
                            class="data-value">{{ (harvestData.harvested_date | date: "dd MMM yyyy") || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">DOC</span>
                          <span class="data-value">{{ harvestData.doc || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Hatchery Name</span>
                          <span class="data-value">{{ harvestData.hatchery_name || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">PL Age</span>
                          <span class="data-value">{{ harvestData.pl_age || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Stocked Number</span>
                          <span class="data-value">{{ harvestData.stocked_number || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Number per m2</span>
                          <span class="data-value">{{ harvestData.number_per_m2 || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Feed brand details</span>
                          <span class="data-value">{{ harvestData.feed_brand_details || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Cummulative feed</span>
                          <span class="data-value">{{ harvestData.cumulative_feed || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Biomass production for pond</span>
                          <span class="data-value">{{ harvestData.biomass_production_per_pond || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Production level/ha</span>
                          <span class="data-value">{{ harvestData.production_level_per_ha || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Final body weight</span>
                          <span class="data-value">{{ harvestData.final_body_weight || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Production level/ha</span>
                          <span class="data-value">{{ harvestData.production_level_per_ha || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">ADG per day</span>
                          <span class="data-value">{{ harvestData.adg_per_day || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Survival rate</span>
                          <span class="data-value">{{ harvestData.survival_rate || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">FCR</span>
                          <span class="data-value">{{ harvestData.fcr || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">Remarks</span>
                          <span class="data-value">{{ harvestData.remarks || '--' }}</span>
                        </div>
                        <div class="data-item">
                          <span class="data-key">ADG per day</span>
                          <span class="data-value">{{ harvestData.adg_per_day || '--' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="visitObject.visited_business_type == 'sme'">
                  <div class="activity-content" *ngIf="visitObjectDetails[0].productDiscussed.length > 0">
                    <h4 *ngIf="visitObjectDetails?.[0].activitiesCount == 1">List of products discussed</h4>
                    <div class="table-container">
                      <table>
                        <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Product</th>
                          <th>Feedback</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                          *ngFor="let list of visitObjectDetails[0].productDiscussed; let i = index">
                          <td>{{ i + 1 }}</td>
                          <td>{{ list.product_name || 'NA' }}</td>
                          <td>{{ list.feedback || 'NA' }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--Part 3: Visit Approvals-->
            <form id="requestForm" role="form" [formGroup]="requestSubmissionFrom">
              <div class="visit-approval" *ngIf="visitObject?.status == 'P'">
                <textarea class="technician-remarks" placeholder="Enter remarks..." rows="2" [(ngModel)]="visitComment"
                          formControlName="comment"></textarea>
                <div *ngIf="submitted && f.comment.errors" style="width: 100%;">
                  <div *ngIf="f.comment.errors.required" class="field-validation-error-message">
                    <img src="../../../../../../assets/images/New_Icons/error-message.svg" height="20px" width="20px">
                    <span>Required</span>
                  </div>
                  <div *ngIf="f.comment.errors.maxlength" class="field-validation-error-message">
                    <img src="../../../../../../assets/images/New_Icons/error-message.svg" height="20px" width="20px">
                    <span>maximum 300 characters allowed</span>
                  </div>
                </div>
                <div class="approve-decline-buttons">
                  <button class="decline-button" (click)="updateVisitByVisitId('R')">
                    Decline
                  </button>
                  <button class="accept-button" (click)="updateVisitByVisitId('A')">
                    Accept
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--Visit details display block in Popup Mode end-->
      </div>
    </div>
  </div>
</div>
